export default __webpack_public_path__ + "static/media/quick-access-patients-image.08287886.jpg";